/* Custom Slidecart – JS für Priorisierten Versand, Upsell-Karussell und Versandzeile.
   Ersetzt die Slide-Cart-App. Hängt sich an die bestehenden Theme-Events
   ('theme:cart:change', 'theme:product:added') und die Cart AJAX API. */

(function () {
  'use strict';

  var SELECTORS = {
    priority: '[data-cart-priority]',
    priorityToggle: '[data-cart-priority-toggle]',
    carousel: '[data-upsell-carousel]',
    carouselTrack: '[data-upsell-carousel-track]',
    carouselPrev: '[data-upsell-carousel-prev]',
    carouselNext: '[data-upsell-carousel-next]',
    carouselSlide: '[data-upsell-carousel-slide]',
    shippingLine: '[data-shipping-line]',
    shippingPrice: '[data-shipping-line-price]',
    cartItemsElement: 'cart-items',
  };

  /* Ein geteilter /cart.js-Fetch für alle Module: parallele Aufrufe innerhalb von
     300ms teilen sich dieselbe Antwort (statt 3 paralleler Requests pro Update). */
  var cartCache = {promise: null, time: 0};

  function fetchCart() {
    var now = Date.now();
    if (cartCache.promise && now - cartCache.time < 300) {
      return cartCache.promise;
    }

    var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';
    cartCache.time = now;
    cartCache.promise = fetch(cartUrl + '.js', {
      headers: {Accept: 'application/json'},
    }).then(function (r) {
      return r.json();
    });

    return cartCache.promise;
  }

  function refreshCartUI() {
    var cartItems = document.querySelector(SELECTORS.cartItemsElement);
    if (cartItems && typeof cartItems.getCart === 'function') {
      cartItems.getCart();
    } else {
      window.location.reload();
    }
  }

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + value;
  }

  /* --- Priorisierter Versand: verstecktes Produkt hinzufügen/entfernen --- */
  function initPriorityShipping() {
    var holder = document.querySelector(SELECTORS.priority);
    if (!holder) return;

    var toggle = holder.querySelector(SELECTORS.priorityToggle);
    var variantId = parseInt(holder.getAttribute('data-variant-id'), 10);
    if (!toggle || !variantId) return;

    function syncState() {
      fetchCart().then(function (cart) {
        var priorityLine = cart.items.find(function (item) {
          return item.variant_id === variantId;
        });

        // Ist der Versand-Zuschlag die einzige Position, wird er automatisch entfernt,
        // damit der Warenkorb korrekt als leer angezeigt wird.
        if (priorityLine && cart.items.length === 1) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json', Accept: 'application/json'},
            body: JSON.stringify({id: priorityLine.key, quantity: 0}),
          }).then(function () {
            toggle.checked = false;
            holder.classList.remove('is-loading');
            refreshCartUI();
          });
          return;
        }

        toggle.checked = Boolean(priorityLine);
        holder.classList.remove('is-loading');
      });
    }

    toggle.addEventListener('change', function () {
      holder.classList.add('is-loading');

      if (toggle.checked) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({id: variantId, quantity: 1}),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (response) {
            if (response.status) {
              toggle.checked = false;
            }
            holder.classList.remove('is-loading');
            refreshCartUI();
          })
          .catch(function () {
            toggle.checked = false;
            holder.classList.remove('is-loading');
          });
      } else {
        fetchCart().then(function (cart) {
          var line = cart.items.find(function (item) {
            return item.variant_id === variantId;
          });

          if (!line) {
            holder.classList.remove('is-loading');
            return;
          }

          fetch('/cart/change.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json', Accept: 'application/json'},
            body: JSON.stringify({id: line.key, quantity: 0}),
          })
            .then(function (r) {
              return r.json();
            })
            .then(function () {
              holder.classList.remove('is-loading');
              refreshCartUI();
            })
            .catch(function () {
              holder.classList.remove('is-loading');
            });
        });
      }
    });

    // Zustand bei jeder Warenkorb-Änderung nachziehen (z. B. Produkt anderweitig entfernt)
    document.addEventListener('theme:cart:change', syncState);
    syncState();
  }

  /* --- Upsell-Karussell: Pfeile + Produkte ausblenden, die schon im Warenkorb sind --- */
  function initUpsellCarousel() {
    var carousel = document.querySelector(SELECTORS.carousel);
    if (!carousel) return;

    var track = carousel.querySelector(SELECTORS.carouselTrack);
    var prev = carousel.querySelector(SELECTORS.carouselPrev);
    var next = carousel.querySelector(SELECTORS.carouselNext);
    if (!track) return;

    function scrollByCard(direction) {
      var slide = track.querySelector(SELECTORS.carouselSlide + ':not(.is-in-cart)');
      var amount = slide ? slide.offsetWidth + 10 : track.offsetWidth;
      track.scrollBy({left: direction * amount, behavior: 'smooth'});
    }

    if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
    if (next) next.addEventListener('click', function () { scrollByCard(1); });

    // Fade-Gradient rechts ausblenden, sobald das Ende erreicht ist
    function updateScrollEnd() {
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      carousel.classList.toggle('is-scroll-end', atEnd);
    }

    track.addEventListener('scroll', updateScrollEnd, {passive: true});
    updateScrollEnd();

    function updateVisibility() {
      fetchCart().then(function (cart) {
        var productIds = cart.items.map(function (item) {
          return String(item.product_id);
        });

        var slides = carousel.querySelectorAll(SELECTORS.carouselSlide);
        var visible = 0;

        slides.forEach(function (slide) {
          var inCart = productIds.indexOf(slide.getAttribute('data-product-id')) > -1;
          slide.classList.toggle('is-in-cart', inCart);
          if (!inCart) visible++;
        });

        carousel.classList.toggle('is-single', visible <= 1);
        carousel.style.display = visible === 0 ? 'none' : '';
        updateScrollEnd();
      });
    }

    document.addEventListener('theme:cart:change', updateVisibility);
    updateVisibility();
  }

  /* --- Versandzeile: unter der Schwelle Preis anzeigen, darüber "Kostenlos" --- */
  function initShippingLine() {
    var line = document.querySelector(SELECTORS.shippingLine);
    if (!line) return;

    var priceEl = line.querySelector(SELECTORS.shippingPrice);
    var rateCents = parseInt(line.getAttribute('data-shipping-rate'), 10) || 0;
    var freeLimitCents = (parseInt(line.getAttribute('data-free-shipping-limit'), 10) || 0) * 100;
    var freeLabel = line.getAttribute('data-free-label') || 'Kostenlos';

    function update() {
      fetchCart().then(function (cart) {
        var isFree = freeLimitCents > 0 && cart.total_price >= freeLimitCents;
        line.style.display = cart.item_count === 0 ? 'none' : '';

        if (priceEl) {
          priceEl.textContent = isFree ? freeLabel : formatMoney(rateCents);
          priceEl.classList.toggle('is-free', isFree);
        }
      });
    }

    document.addEventListener('theme:cart:change', update);
    update();
  }

  /* Progress-Bar "erwärmt" sich: ab 70% der Free-Shipping-Schwelle wird sie grün */
  function initProgressWarmth() {
    var bars = document.querySelectorAll('.drawer--cart [data-free-shipping]');
    if (!bars.length) return;

    function update() {
      fetchCart().then(function (cart) {
        bars.forEach(function (bar) {
          var limit = (parseInt(bar.getAttribute('data-free-shipping-limit'), 10) || 0) * 100;
          var warm = limit > 0 && cart.total_price >= limit * 0.7;
          bar.classList.toggle('is-warm', warm);
        });
      });
    }

    document.addEventListener('theme:cart:change', update);
    update();
  }

  /* Mobile: ⓘ am "Priorisierter Versand" klappt die Beschreibung auf/zu */
  function initPriorityInfo() {
    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-priority-info]');
      if (!btn) return;
      var holder = btn.closest('.cart-priority');
      if (holder) holder.classList.toggle('is-info-open');
    });
  }

  function init() {
    initPriorityShipping();
    initUpsellCarousel();
    initShippingLine();
    initProgressWarmth();
    initPriorityInfo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
